export {default as path} from "./path.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-path/src/index.js
// module id = 41
// module chunks = 0